import { useAssetsIsSiteAdmin } from '@atlassian/jira-assets-tenant-context-provider/src/index.tsx';
import { useInsightGlobalConfig } from '@atlassian/jira-servicedesk-insight-global-configuration-store/src/services/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createRouterSelector } from '@atlassian/react-resource-router';
import { ASSETS_DATA_MANAGER_ROLES_BY_PAGE } from '../../common/constants.tsx';

export const useUrl = createRouterSelector(({ match }) => match.url);

export const useAssetsDataManagerUserAuth = () => {
	const url = useUrl();
	const isSiteAdmin = useAssetsIsSiteAdmin();
	const [{ dataManager, loading: isInsightGlobalConfigLoading }] = useInsightGlobalConfig();
	const {
		isProvisioned: isDataManagerProvisioned,
		provisioningLoading,
		myRoles,
		myRolesLoading,
	} = dataManager ?? {};
	const isLoading = isInsightGlobalConfigLoading || myRolesLoading || provisioningLoading;

	if (
		!url.startsWith('/jira/assets/data-manager') ||
		isLoading ||
		!fg('assets_data_manager_jira_spa')
	) {
		return { isAssetsDataManagerUnauthorizedUser: false };
	}

	let allowedRoles: string[] = [];
	let isAuthorized = false;
	if (url.startsWith('/jira/assets/data-manager/getting-started')) {
		allowedRoles = ASSETS_DATA_MANAGER_ROLES_BY_PAGE.GettingStartedPage;
		isAuthorized = myRoles?.some((role) => allowedRoles.includes(role)) || isSiteAdmin;
	}
	if (url.startsWith('/jira/assets/data-manager/object-classes/view')) {
		allowedRoles = ASSETS_DATA_MANAGER_ROLES_BY_PAGE.ObjectClassView;
		isAuthorized = myRoles?.some((role) => allowedRoles.includes(role)) || isSiteAdmin;
	}
	if (url.startsWith('/jira/assets/data-manager/object-classes')) {
		allowedRoles = ASSETS_DATA_MANAGER_ROLES_BY_PAGE.DataSource;
		isAuthorized = myRoles?.some((role) => allowedRoles.includes(role)) || isSiteAdmin;
	}

	return {
		isAssetsDataManagerUnauthorizedUser: !isAuthorized || !isDataManagerProvisioned,
	};
};
